import * as d3 from 'd3-selection'
import cartesian from './cartesian'

const Tooltip = function (id, contents, rows) {
  var e = d3.select('#' + id)

  this.el = e.size() ? e : d3.select('body')
                               .append('div')
                                 .attr('class', 'sb-chart-tooltip')
                                 .attr('id', id)

  // Used if the chart caller overrides the contents/rows functions
  this.contents = contents
  this.rows = rows
}

Tooltip.prototype.update = function (e, data, scalers) {
  if (this.chart.layout.hasYAxis) {
    cartesian(this, e, data, scalers)
  }
}

Tooltip.prototype.show = function () {
  this.el.classed('visible', true)
  return this
}

Tooltip.prototype.hide = function () {
  this.el.classed('visible', false)
  return this
}

Tooltip.prototype._setFlip = function (val) {
  this.flip = val
  return this
}

Tooltip.prototype._position = function (x, y, maxX, maxY) {
  var padding = 10
    , bb = this.el.node().getBoundingClientRect()
    , scrollTop  = document.documentElement.scrollTop || document.body.scrollTop
    , scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
    , left = x - bb.width / 2 + scrollLeft
    , top = y - bb.height + scrollTop - padding
    , flip = this.flip || top < 0
    , clazz = []

  if (flip) {
    // The top of the tooltip would be above the browser, so position it below the point
    this.el.style('top', (y + padding) + 'px')
    clazz.push('sb-chart-tooltip-below')
  } else {
    // normal style
    this.el.style('top', top + 'px')
    clazz.push('sb-chart-tooltip-above') // default
  }

  if (left < 0) {
    // Align right
    left = x - (bb.width * .1) + scrollLeft
    clazz.push('sb-chart-tooltip-right')
  } else if (left + bb.width > document.body.clientWidth + document.documentElement.scrollLeft) {
    // Align left
    left = x - (bb.width * .9) + scrollLeft
    clazz.push('sb-chart-tooltip-left')
  }

  this.el.style('left', left + 'px')
         .classed(`sb-chart-tooltip-above
                   sb-chart-tooltip-below
                   sb-chart-tooltip-left
                   sb-chart-tooltip-right`, false) // Reset all position related classes
         .classed(clazz.join(' '), true)

  return this
}

Tooltip.prototype.destroy = function () {
  this.el.remove()
  return this
}

Tooltip.prototype._html = function (html) {
  this.el.html(html)
  return this
}

export default Tooltip
